<template lang="pug">
#sub-empresa-tabela-gestao-contrato-originacao
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :key="listagemTableKey('subempresa-gestao-ar', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%'
        )
            el-table-column(
                prop='numeroContrato',
                :label='$t("mensagens.subEmpresaGestao.tabela.numeroContrato")',
                sortable='custom'
            )
            el-table-column(
                prop='materialNome',
                :label='$t("mensagens.subEmpresaGestao.tabela.cultura")',
                sortable
            )
            el-table-column(
                prop='safraAno',
                :label='$t("mensagens.subEmpresaGestao.tabela.safra")',
                sortable='custom'
            )
            el-table-column(
                prop='dataContrato',
                :label='$t("mensagens.subEmpresaGestao.tabela.dataContrato")',
                sortable='custom'
            )
            el-table-column(
                prop='volumeContratado',
                :label='$t("mensagens.subEmpresaGestao.tabela.volumeContratado")',
                sortable='custom'
            )
                .template(slot-scope='scope')
                    span {{ scope.row.volumeContratado + ' t' }}
            el-table-column(
                :label='$t("mensagens.subEmpresaGestao.tabela.saldoRestante")'
            )
                .template(slot-scope='scope')
                    span {{ scope.row.saldoRestante + ' t' }}
            el-table-column(
                prop='statusSubEmpresa',
                :label='$t("mensagens.subEmpresaGestao.tabela.status")',
                sortable='custom'
            )
                .template(slot-scope='scope')
                    .status-processamento {{ $t(`mensagens.subEmpresaGestao.filtrosAvancados.statusSelecao.${scope.row.statusSubEmpresaCodigo}`) }}
            el-table-column(
                prop='nomeMunicipio',
                :label='$t("mensagens.subEmpresaGestao.tabela.municipiosAR")',
                sortable='custom',
                width='150'
            )
                .template(slot-scope='scope')
                    .status-processamento {{ scope.row.localidadeNivelUmNome }}
            el-table-column(
                :label='$t("mensagens.subEmpresaGestao.tabela.acoes.acoes")',
                align='center'
            )
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                v-if='scope.row.statusSubEmpresaCodigo !== "AGUARDANDO_PREENCHIMENTO"',
                                @click.native='visualizarProcessamento(scope.row.numeroContrato)'
                            ) {{ $t('mensagens.subEmpresaGestao.tabela.acoes.visualizar') }}
                            el-dropdown-item(
                                icon='el-icon-edit',
                                v-if='codigosPreencher[scope.row.statusSubEmpresaCodigo]',
                                @click.native='irParaContrato(scope.row.numeroContrato)'
                            ) {{ $t('mensagens.subEmpresaGestao.tabela.acoes.preencher') }}
                            el-dropdown-item(
                                icon='el-icon-edit',
                                v-if='codigosEdicao[scope.row.statusSubEmpresaCodigo]',
                                @click.native='irParaContrato(scope.row.numeroContrato)'
                            ) {{ $t('mensagens.subEmpresaGestao.tabela.acoes.editar') }}
                            el-dropdown-item(
                                icon='el-icon-view',
                                v-if='visualizaAnalise[scope.row.statusSubEmpresaCodigo]',
                                @click.native='visualizarAnalise(scope.row.numeroContrato)'
                            ) {{ $t('mensagens.subEmpresaGestao.tabela.acoes.visualizarDetalheAnalise') }}
                            el-dropdown-item(
                                v-if='scope.row.statusSubEmpresaCodigo === "ENVIADO"',
                                @click.native='exportarRelatorioContrato(scope.row.numeroContrato, false)'
                            )
                                i.mdi.mdi-file-document-outline
                                span {{ $t('mensagens.subEmpresaGestao.tabela.acoes.relatorioSimplificado') }}
                            el-dropdown-item(
                                v-if='scope.row.statusSubEmpresaCodigo === "ENVIADO"',
                                @click.native='exportarRelatorioContrato(scope.row.numeroContrato, true)'
                            )
                                i.mdi.mdi-file-document-multiple-outline
                                span {{ $t('mensagens.subEmpresaGestao.tabela.acoes.relatorioCompleto') }}

            template(slot='empty')
                el-empty(
                    :description='$t("mensagens.subEmpresaGestao.tabela.acoes.semDados")'
                )

    .tabela-gestao-contrato-originacao__paginacao
        span.pagina
            | {{ paginacao.total }} {{ paginacao.total > 1 ? $t('mensagens.subEmpresaGestao.tabela.acoes.contratos') : $t('mensagens.subEmpresaGestao.tabela.acoes.contrato') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'SubEmpresaTabelaGestaoContratoOriginacao',
    components: {
        ModalDetalheAnalise
    },
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            codigosPreencher: {
                AGUARDANDO_PREENCHIMENTO: 'AGUARDANDO_PREENCHIMENTO'
            },
            codigosEdicao: {
                EM_CADASTRAMENTO: 'EM_CADASTRAMENTO',
                EM_PROCESSAMENTO: 'EM_PROCESSAMENTO',
                EM_ANDAMENTO_VOLUME_INCONPLETO:
                    'EM_ANDAMENTO_VOLUME_INCONPLETO',
                EM_ANDAMENTO_REQUER_ATENCAO: 'EM_ANDAMENTO_REQUER_ATENCAO',
                EM_ANDAMENTO_AGUARDANDO_ENVIO: 'EM_ANDAMENTO_AGUARDANDO_ENVIO',
                DISCREPANCIA: 'DISCREPANCIA'
            },
            visualizaAnalise: {
                PROCESSADO: 'PROCESSADO'
            },
            mostrarModalCompartilhamentoRelatorioRastreabilidade: false,
            numeroContratoSelecionado: ''
        };
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            const order = {
                prop: column.prop,
                order: column.order === 'ascending' ? 'asc' : 'desc'
            };

            this.$emit('ordenarTabela', order);
        },
        visualizarProcessamento(numeroContrato) {
            this.$router.push({
                name: 'VisualizarProcessamentoContratoOriginacao',
                params: { numeroContrato }
            });
        },
        visualizarAnalise() {},

        async irParaContrato(numeroContrato) {
            this.$router.push({
                name: 'PreencherContratoOriginacao',
                params: { numeroContrato }
            });
        },

        async exportarRelatorioContrato(numeroContrato, listarTerritorios) {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabela.conectarVegaAPi'
                    )
                });
                return;
            }

            if (this.usuarioLogado) {
                try {
                    subscribe(
                        `${this.usuarioLogado.idKeyCloack}/subempresa/relatorio/exportado`,
                        response => {
                            if (response) {
                                const linkSource = `data:application/pdf;base64,${response}`;
                                const link = document.createElement('a');
                                const fileName =
                                    'relatorio-contrato-originacao.pdf';
                                link.href = linkSource;
                                link.download = fileName;
                                document.body.append(link);
                                link.click();
                                link.remove();
                            } else {
                                this.$notify.error({
                                    message: this.$t(
                                        'mensagens.subEmpresaGestao.tabela.relatorioOriginacao'
                                    )
                                });
                            }
                            if (this.notificacaoExportarRelatorio) {
                                this.notificacaoExportarRelatorio.close();
                            }
                            disconnect();
                        }
                    );

                    ContratoOriginacaoServiceSubEmpresa.exportarRelatorioContratoSubempresa(
                        numeroContrato,
                        listarTerritorios
                    );

                    this.notificacaoExportarRelatorio = this.$notify({
                        message:
                            '<i class="el-icon-loading" style="font-size: 20px; color: #043c5a;"></i> O download do relatório está sendo processado!',
                        duration: 600000,
                        dangerouslyUseHTMLString: true,
                        showClose: false
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabela.exportarPDF'
                        )
                    });
                    if (this.notificacaoExportarRelatorio) {
                        this.notificacaoExportarRelatorio.close();
                    }
                    disconnect();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabela.usuarioDeslogado'
                    )
                });
                disconnect();
            }
        }
    }
};
</script>
<style lang="scss">
#sub-empresa-tabela-gestao-contrato-originacao {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 10px;

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }
    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }
    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }
    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
}
</style>
